export default __webpack_public_path__ + "static/media/D2emu.f6f4f4ef.png";